<template>
  <section
    :class="[
      'relative bg-cover bg-fixed bg-top bg-no-repeat bg-[#00284F] pb-[100px]',
      backgroundClass,
    ]"
  >
    <div
      class="flex flex-col justify-center items-center pt-28 px-4 md:pt-36 lg:pt-40"
      style="font-family: Oxanium, sans-serif"
    >
      <div v-motion-pop-visible class="text-center text-white uppercase">
        <p class="text-5xl lg:text-6xl font-bold">Bounties</p>
      </div>

      <!-- Leaderboard Switch Slider -->
      <div
        v-motion-pop-visible
        class="relative flex mt-10 bg-gradient-to-b from-[#1D1D1D] via-[#1D1D1D] to-[#313B44] rounded-[20px] p-2 max-w-xl w-full justify-between overflow-hidden"
      >
        <!-- Sliding Background -->
        <div
          class="absolute top-2 bottom-2 w-[32%] rounded-[10px] transition-all duration-300 ease-in-out z-0 bg-gradient-to-r from-[#1294F0]/20 via-[#1294F0]/50 to-[#1294F0]/20"
          :class="{
            'left-2': currentLeaderboard === 'metaspins',
            'left-1/3': currentLeaderboard === 'empiredrop',
            'left-2/3 lg:left-[380px]': currentLeaderboard === 'dailyspins',
          }"
        ></div>

        <!-- Buttons -->
        <button
          v-for="site in ['metaspins', 'empiredrop', 'dailyspins']"
          :key="site"
          @click="setLeaderboard(site)"
          class="relative z-10 flex items-center justify-center w-1/3 py-2 rounded-[10px] transition-all duration-200 text-white"
          :class="currentLeaderboard !== site ? 'opacity-50 hover:opacity-80' : ''"
        >
          <img
            :src="getLeaderboardImage(site)"
            alt=""
            :class="[
              'h-auto transition-all duration-200',
              site === 'dailyspins' ? 'w-[80px] sm:w-[110px]' : 'w-[90px] sm:w-[140px]',
            ]"
          />
        </button>
      </div>
    </div>

    <!-- Challenge Sections -->
    <div v-if="selectedChallenge == 1">
      <MetaspinsChallengesSection />
    </div>
    <div v-if="selectedChallenge == 2">
      <EmpireDropChallengesSection />
    </div>
    <div v-if="selectedChallenge == 3">
      <DailySpinsChallengesSection />
    </div>
  </section>
</template>

<script>
import { defineComponent } from "vue";
import { useRoute } from "vue-router";

import DailySpinsChallengesSection from "@/sections/DailySpinsChallengesSection.vue";
import MetaspinsChallengesSection from "@/sections/MetaspinsChallengesSection.vue";
import EmpireDropChallengesSection from "@/sections/EmpireDropChallengesSection.vue";

export default defineComponent({
  components: {
    MetaspinsChallengesSection,
    EmpireDropChallengesSection,
    DailySpinsChallengesSection,
    // PackdrawChallengesSection,
    // ChickenGGChallengesSection,
  },
  data() {
    const route = useRoute();
    const validTypes = ["metaspins", "empiredrop", "dailyspins", "raingg"];
    return {
      currentLeaderboard: validTypes.includes(route.query.type)
        ? route.query.type
        : "metaspins",
      selectedChallenge: 1,
    };
  },
  computed: {
    backgroundClass() {
      switch (this.currentLeaderboard) {
        case "dailyspins":
          return "bg-dailyspins-bounties-bg";
        case "metaspins":
          return "bg-metaspins-bounties-bg";
        case "empiredrop":
          return "bg-empiredrop-bounties-bg";
          case "raingg":
          return "bg-raingg-bounties-bg";
        default:
          return "";
      }
    },
    leaderboardImage() {
      switch (this.currentLeaderboard) {
        case "dailyspins":
          return require("@/assets/dailyspins-leaderboard-text.png");
        case "metaspins":
          return require("@/assets/metaspins-leaderboard-text.png");
        case "empiredrop":
          return require("@/assets/empiredrop-leaderboard-text.png");
        default:
          return "";
      }
    },
    leaderboardSwitchImages() {
      return {
        dailyspins: {
          active: require("@/assets/dailyspins-active.png"),
          inactive: require("@/assets/dailyspins-inactive.png"),
        },
        metaspins: {
          active: require("@/assets/metaspins-active.png"),
          inactive: require("@/assets/metaspins-inactive.png"),
        },
        empiredrop: {
          active: require("@/assets/empiredrop-active.png"),
          inactive: require("@/assets/empiredrop-inactive.png"),
        },
      };
    },
  },
  methods: {
    setLeaderboard(site) {
      const leaderboardChallenges = {
        metaspins: 1,
        empiredrop: 2,
        dailyspins: 3,
      };
      this.selectedChallenge = leaderboardChallenges[site] ?? 2;

      if (this.currentLeaderboard !== site) {
        this.currentLeaderboard = site;
      }
    },
    getLeaderboardImage(site) {
      return this.currentLeaderboard === site
        ? this.leaderboardSwitchImages[site].active
        : this.leaderboardSwitchImages[site].inactive;
    },
    isMobile() {
      return window.innerWidth < 1024;
    },
  },
});
</script>

<style scoped>
.leaderboard-btn:hover .leaderboard-span {
  border-color: #1294f0;
}
.bounties-frame-bg {
  background-image: url("../assets/bounties-frame-bg.png");
  background-repeat: no-repeat;
  background-size: contain;
}
</style>
